/* eslint-disable @next/next/no-img-element */

"use client";

import Image from "next/image"
import { buttonVariants } from "@/components/fun-ui/Button";
import { useEffect, useState, Fragment, useMemo } from "react";
import { useGlobalConfig } from "@/stores/appStore";
import Link from "next/link";
import { cn } from "@/lib/utils";
import Loading from "@/components/Loading";


export function LiteratureTable() {
  const {
    value: globalConfig,
    fetch: fetchGlobalConfig,
  } = useGlobalConfig().globalConfig;

  const featuresData = useMemo(() => {
    return globalConfig?.pc.literatureTable;
  }, [globalConfig]);

  useEffect(() => {
    fetchGlobalConfig();
  }, [fetchGlobalConfig]);

  const [cookieHasNickname, setCookieHasNickname] = useState(true);
  useEffect(() => {
    setCookieHasNickname(document.cookie.indexOf('nickname') !== -1);
  }, []);

  if (!featuresData) {
    return (
      <div className="h-screen w-screen relative">
        <Loading size="lg" className="-mt-20"></Loading>
      </div>
    )
  }
  return (
    <div
      className="flex flex-1 relative flex-col overflow-hidden bg-[background]"
    >
      {
        featuresData.backgroundImage && (
          <Image className="absolute -top-[71px]" src={featuresData.backgroundImage} width={2632} height={712} alt="Literature Table" />
        )
      }
      <section className="container mx-auto flex flex-col items-center justify-center mt-[100px] relative z-1">
        <h2 className="text-[48px] font-semibold text-foreground text-center">
          {featuresData.title}
        </h2>
        <p
          className={cn(
            "text-center text-muted-foreground mt-5",
          )}>
          {featuresData.subtitle}
        </p>
        <div className="container mx-auto flex justify-center mt-16">
          <Link
            href={cookieHasNickname ? "/papers" : "/login"}
            replace={false}
            className={cn(
              buttonVariants({ variant: 'default' }),
              "cursor-pointer",
              "w-[180px] h-[52px] rounded-full text-[18px] font-medium"
            )}
          >{cookieHasNickname ? "立即开始" : "立即开始"}</Link>
        </div>
      </section>
      <div className="container mx-auto min-h-screen" id="content">
        <div className="-mx-[759px] w-[2604px]">
          {
            featuresData?.features.map((feature: any) => (
              <Fragment
                key={feature.url}
              >
                <img
                  src={feature.url}
                  alt={feature.title}
                  width={2604}
                />
                <div className="sr-only">
                  <h2>{feature.title}</h2>
                  {
                    feature.caption.split('/n').map((str: string, index: number) => {
                      return <p key={index}>{str}</p>
                    })
                  }
                </div>
              </Fragment>
            ))
          }
        </div>
      </div>
    </div>
  )
}
